import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/i18n";
import { withLangPrefix } from "@/lib/langRoute";
import { devLog } from "@/lib/devLog";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const LanguageSwitcher = ({ variant = "default" }) => {
  const { i18n, t } = useTranslation();
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === (i18n.resolvedLanguage || i18n.language)) || SUPPORTED_LANGUAGES[0];

  const handle = (code) => {
    try { localStorage.setItem("dc_lang", code); }
    catch (e) { devLog.warn("LanguageSwitcher: failed to persist language", e); }
    // Reload with new language prefix in URL.
    const target = withLangPrefix(window.location.pathname + window.location.search + window.location.hash, code);
    window.location.assign(target);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={`language-switcher-${variant}`}
          aria-label={t("nav.language")}
          className={`inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-semibold text-slate-700 hover:border-slate-300 hover:bg-slate-50 ${
            variant === "mobile" ? "w-full justify-center" : ""
          }`}
        >
          <Globe className="h-3.5 w-3.5" />
          {current.label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="language-switcher-menu" className="min-w-[140px] bg-white">
        {SUPPORTED_LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => handle(l.code)}
            className={`cursor-pointer text-sm ${current.code === l.code ? "bg-blue-50 text-blue-700 font-semibold" : ""}`}
          >
            {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
